import React from 'react';
import {
  Text,
  Box,
  Button,
  ButtonAppearance,
  Modal,
  ModalClose,
  ModalBody,
  ModalFooter,
  ModalSize,
} from '@bechtel/gds';
import { ModalHeaderStyled, ModalSubHeader } from '@bechtel/client-common';
import { t, Trans } from '@lingui/macro';

export const ConfirmDeletePlan = ({ onClose, onConfirm, workPackageTag }) => {
  return (
    <Modal visible closable onDismiss={onClose} size={ModalSize.LARGE}>
      <ModalHeaderStyled title={t`Planned Activites Outside Date Range`}>
        <ModalClose onClick={onClose}></ModalClose>
      </ModalHeaderStyled>
      <ModalSubHeader>
        <Text family="graphik" size="500" color="grey.1000" weight="600">
          {t`Workpackage(s)`} : {workPackageTag ? workPackageTag : t`Multiple Work Packages`}
        </Text>
      </ModalSubHeader>

      <ModalBody>
        <Box flexDirection={{ sm: 'column' }} px={{ sm: '500' }} py={{ sm: '600' }}>
          <Text family="graphik">
            <Trans>This work package has activities planned outside the start and end dates.</Trans>
          </Text>
          <Text family="graphik">
            <Trans>If you continue, all plans will be lost</Trans>
          </Text>
          <br></br>
          <br></br>
          <Text family="graphik">
            <Trans>Are you sure you want to continue?</Trans>
          </Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <Button appearance={ButtonAppearance.SECONDARY} onClick={onClose}>
              <Trans>Cancel</Trans>
            </Button>
          </Box>
          <Box>
            <Button type="submit" appearance={ButtonAppearance.SECONDARY} onClick={onConfirm}>
              <Trans>Continue</Trans>
            </Button>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
